import { Dtos, type SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { projectedAccountExposureQueryKey } from "../account.keys";

export const useAdminFetchProjectedAccountExposure = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const { data, error, isLoading, refetch } = useQuery({
		queryKey: projectedAccountExposureQueryKey(accountId),
		queryFn: async () =>
			await get<Dtos.SuretyAccount.Exposure.Projected.Get.Response>(
				`/v2/admin/surety/accounts/${accountId}/exposure/projected`,
			),
		retry: false,
	});

	return {
		exposure: data,
		exposureError: error,
		exposureIsLoading: isLoading,
		refetchExposure: refetch,
	};
};
